module.exports = __webpack_public_path__ + "static/media/cards-books-about.265ecbfa.jpg";